import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=2e45c786&scoped=true&"
import script from "./public-header.vue?vue&type=script&lang=js&"
export * from "./public-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45c786",
  null
  
)

export default component.exports